import SOURCE_ERRORS_TAB from '../../models/sourceErrorsTab.js';

class SourceErrorsModalController {
  constructor(data, modalLoaderService) {
    this.data = data;
    this.tab = SOURCE_ERRORS_TAB;
    this.modalLoaderService = modalLoaderService;
    this.name = 'sourceErrorsModal';
  }

  closeModal() {
    this.modalLoaderService.close();
  }
}

SourceErrorsModalController.$inject = ['data', 'modalLoaderService'];

export default SourceErrorsModalController;


// WEBPACK FOOTER //
// ./app/components/sourceErrorsModal/sourceErrorsModal.controller.js